import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=507769b0&scoped=true"
import script from "./TagsComponent.vue?vue&type=script&lang=js"
export * from "./TagsComponent.vue?vue&type=script&lang=js"
import style0 from "./TagsComponent.vue?vue&type=style&index=0&id=507769b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507769b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507769b0')) {
      api.createRecord('507769b0', component.options)
    } else {
      api.reload('507769b0', component.options)
    }
    module.hot.accept("./TagsComponent.vue?vue&type=template&id=507769b0&scoped=true", function () {
      api.rerender('507769b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/folders/TagsComponent.vue"
export default component.exports